// extracted by mini-css-extract-plugin
module.exports = {"descriptor":"descriptor_descriptor__2u9lP","default":"descriptor_default__1NaeM"};